import { Head, Link, useForm, usePage } from '@inertiajs/react'
import GoogleSignInButton from '../../components/GoogleSignInButton'
import AuthPanel from '../../components/AuthPanel'
import TextField from '../../components/TextField'
import { buttonClass, linkClass } from '../../components/ui'
import type { SharedProps } from '../../types'

export default function SessionsNew() {
  const { google_sign_in_enabled } = usePage<SharedProps>().props
  const form = useForm({ email_address: '', password: '' })

  return (
    <>
      <Head title="Sign in" />
      <AuthPanel
        title="Sign in"
        description="Welcome back to Lie Angle Lab."
        footer={
          <div className="flex flex-wrap items-center justify-between gap-4">
            <Link href="/passwords/new" className={linkClass}>Forgot password?</Link>
            <Link href="/registration/new" className={linkClass}>Create an account</Link>
          </div>
        }
      >
        <form
          className="space-y-5"
          aria-busy={form.processing}
          onSubmit={(e) => {
            e.preventDefault()
            form.post('/session')
          }}
        >
          <TextField label="Email" name="email_address" type="email" autoComplete="username" required
            value={form.data.email_address} onChange={(v) => form.setData('email_address', v)} />
          <TextField label="Password" name="password" type="password" autoComplete="current-password" required
            value={form.data.password} onChange={(v) => form.setData('password', v)} />
          <button type="submit" className={`${buttonClass} w-full`} disabled={form.processing}>
            {form.processing ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
        {google_sign_in_enabled && <GoogleSignInButton />}
      </AuthPanel>
    </>
  )
}
